const itemsPerPage: number = 6;
const listItemPerPage: number = 15;

export {itemsPerPage, listItemPerPage};